import React from 'react';
import GoogleMap from 'google-map-react';

const { envVars } = require('next/config').default().publicRuntimeConfig;

const Map = (props) => {
  const {
    defaultZoom,
    defaultCenter,
    mapZoom,
    mapCenter,
    handleMarkerClick,
    handleMapOnChange,
    renderMapMarkers = () => {},
    mapOptions,
    ...restOfProps
  } = props;
  const options = {
    fullscreenControl: false,
    ...mapOptions,
  };
  return (
    <GoogleMap
      yesIWantToUseGoogleMapApiInternals
      bootstrapURLKeys={{ key: envVars.GOOGLE_MAPS_API_KEY }}
      zoom={mapZoom}
      defaultZoom={defaultZoom}
      center={mapCenter}
      onChildClick={handleMarkerClick}
      defaultCenter={defaultCenter}
      onChange={handleMapOnChange}
      {...restOfProps}
      options={options}
    >
      {renderMapMarkers()}
    </GoogleMap>
  );
};
export { Map };
